<template>
  <div class="flex-table-row flex-table-body">
    <div class="flex-table-row-item" data-heading="Service"><span v-if="issue.serviceCode">{{ issue.serviceCode }} ({{issue.caseNumber}})</span></div>
    <div class="flex-table-row-item" data-heading="TODO">{{ issue.title }}</div>
    <div class="flex-table-row-item" data-heading="Description">
      <div class="flex-table-row-item">{{ issue.message }}</div>
      <div class="flex-table-row-item">
        <button class="button is-success is-outlined" :disabled="disabled" v-translate @click="toggleModal()">Fix Now</button>
      </div>
    </div>
    <card-modal-component
      :show="show_modal"
      transition="fade"
      ref="modal"
      :options="{ hasOkBtn: { text: 'Resolve' }, hasCancelBtn: { enabled: true }}"
      @handleOk="updateIssue($event)"
      @handleCancel="toggleModal()"
      @deactivate="toggleModal()"
      title="Resolve issue">
      <template v-if="issue.formDatas" slot="card-content">
        <form-component
          v-for="formDescriptor in issue.formDescriptors"
          class="issue-modal"
          :formDescriptor="formDescriptor"
          :formData="getFormDataForDescriptor(formDescriptor)"
          :key="formDescriptor.id">
        </form-component>
        <p class="help is-danger"
          v-if="empty_comment"
          v-translate>
          A comment is required
        </p>
        <div v-if="issue.isReviewIssue">
          <label class="label" v-translate>Comment:</label>
          <textarea
            class="textarea"
            v-model="issue.text"
            cols="30"
            rows="5">
          </textarea>
        </div>
      </template>
    </card-modal-component>
  </div>
</template>
<script>
  import { mapActions, mapMutations } from 'vuex'
  import CardModalComponent from '@/components/layout/modal/CardModalComponent'
  import FormComponent from '@/components/form/FormComponent'
  import { formHandlerMixin } from '@/mixins/mixins'
  import { CaseState } from '@/classes/case/Case'

  export default {
    name: 'issue-view',
    mixins: [formHandlerMixin],
    components: {
      CardModalComponent,
      FormComponent
    },
    data () {
      return {
        empty_comment: false,
        show_modal: false,
        submitRequest: null
      }
    },
    props: {
      issue: {
        type: Object,
        required: true
      },
      disabled: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      formDatas () {
        return this.issue.formDatas
      }
    },
    methods: {
      ...mapActions([
        'updateIssueForm',
        'updateIssueReviewComment',
        'getCases',
        'successMessage'
      ]),
      ...mapMutations([
        'removeIssue'
      ]),
      toggleModal () {
        this.show_modal = !this.show_modal
      },
      updateIssue (btn) {
        if (this.issue.isReviewIssue) {
          if (this.issue.text.length === 0) {
            this.empty_comment = true
            btn.enable()
            return
          }
        }
        this.submitRequest = this.updateIssueForm
        this.submitForm(this.issue, btn, this.updateIssueCallback)
      },
      updateIssueCallback (response) {
        if (this.issue.isReviewIssue) {
          let postData = { id: this.issue.id, comment: this.issue.text }
          this.updateIssueReviewComment(postData).catch((err) => {
            this.handleError(err)
          })
        }
        this.show_modal = false
        this.$refs.modal.closeModal().then((response) => {
          this.removeIssue(this.issue)
          this.$emit('issueResolved')
        })
        this.getCases({ 'state': CaseState.ongoingStates() })
        this.successMessage(this.$ngettext('Issue resolved'))
      }
    }
  }
</script>
